import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '@shared/lib/services/data.service';
import { LocaleService } from '@shared/lib/services/locale.service';
import { Market, UsanaMarketService } from '@usana/ux/markets';

@Component({
  selector: 'u-dm',
  template:
    '<router-outlet></router-outlet>' +
    '<u-locale-confirmation *ngIf="showMarketConfirmation" ' +
    '[locale]="resolvedLocale" ' +
    '(chosenOne)="youWereTheChosenLocale($event)"></u-locale-confirmation>',
  standalone: false,
})
export class DetermineMarketComponent implements OnInit {
  showMarketConfirmation: boolean;
  resolvedLocale: string;

  constructor(
    private route: ActivatedRoute,
    private usanaMarketService: UsanaMarketService,
    private localeService: LocaleService,
    private readonly dataService: DataService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.dataService.init(); // this determines if we are prerender
    this.route.data.subscribe((data): void => {
      const market = data['market'] as Market;
      if (!market?.currentMarketId) {
        // No marketId, redirect to default locale/home
        const defaultLocale = this.localeService.getLocale() || this.localeService['defaultLocale'] || 'enu-US';
        this.router.navigate(['/', defaultLocale, 'home']);
        return;
      } else if (this.router.url === `/${market.currentMarketId}`) {
        this.router.navigate(['/', market.currentMarketId, 'home']);
        return;
      }
      this.resolvedLocale = market.currentMarketId;
      // check if they have confirmed, and we are fancy mode (not prerender)
      this.showMarketConfirmation = this.dataService.isFancyMode() && !this.localeService.hasConfirmedLocaleCookie();
    });
  }

  youWereTheChosenLocale(chosenLocale: string): void {
    // conform
    this.showMarketConfirmation = false;
    this.localeService.bumpConfirmedLocaleCookie();

    if (chosenLocale !== this.resolvedLocale) {
      // bring balance by switching locales
      this.usanaMarketService.setMarketId(chosenLocale);
    }
  }
}
